import { HttpClient } from '@angular/common/http';
// import { environment } from '../../../../environments/environment';
import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../config/config.service";
var RegisterMachineHttpService = /** @class */ (function () {
    function RegisterMachineHttpService(http, configService) {
        this.http = http;
        this.configService = configService;
        this.apiName = this.configService.get('host');
    }
    RegisterMachineHttpService.prototype.initMachine = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/init_machine';
            var params = {
                body: formObj
            };
            API.post(_this.apiName, path, params).then(function (resp) {
                observer.next(resp);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    RegisterMachineHttpService.prototype.getRegistration = function (serialNo) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_mac_registration/' + serialNo;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    RegisterMachineHttpService.prototype.updateRegistration = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/update_mac_registration';
            var params = {
                body: formObj
            };
            API.put(_this.apiName, path, params).then(function (resp) {
                observer.next(resp);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    RegisterMachineHttpService.prototype.getRegions = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-regions';
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    RegisterMachineHttpService.prototype.getTerritories = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-territories';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    RegisterMachineHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RegisterMachineHttpService_Factory() { return new RegisterMachineHttpService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: RegisterMachineHttpService, providedIn: "root" });
    return RegisterMachineHttpService;
}());
export { RegisterMachineHttpService };
